
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


const debouncedCheckUpsellCheckbox = debounce(checkUpsellCheckbox, 300);
const debouncedCheckUpsellInCart = debounce(checkUpsellInCart, 300);


document.addEventListener("DOMContentLoaded", function () {
    debouncedCheckUpsellCheckbox();
  checkCartAndShowUpsell();


    document.body.addEventListener("click", function (event) {
        if (event.target.matches("[name='add']") || event.target.closest("[name='add']")) {
            let productId = event.target.getAttribute("data-variant-id"); 
            addMainProduct(productId);
        }
    });


    document.body.addEventListener("change", function (event) {
        if (event.target.matches("[data-upsell-id]")) {
            toggleUpsell(event.target);
        }
    });
});


document.addEventListener("cart:refresh", function () {
    console.log("Cart refresh event triggered");
    debouncedCheckUpsellInCart();
    debouncedCheckUpsellCheckbox();
  checkCartAndShowUpsell();
});


async function addMainProduct(productId) {
    try {
        let response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: productId, quantity: 1 }),
        });

        let data = await response.json();
        console.log("Main product added:", data);
             setTimeout(() => {
        checkAndAddUpsellProduct();
      }, 2000);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        debouncedCheckUpsellCheckbox();
        checkCartAndShowUpsell();
        
      updateCartCount();
    } catch (error) {
        console.error("Error adding main product:", error);
    }
}



async function updateCartCount() {
    try {
        let response = await fetch("/cart.js"); 
        let cart = await response.json();

        let cartCountElements = document.querySelectorAll("cart-count");

        cartCountElements.forEach(cartCountElement => {
            cartCountElement.textContent = cart.item_count; 
            cartCountElement.setAttribute("aria-label", `${cart.item_count} Artikel`);
        });

    } catch (error) {
        console.error("Error updating cart count:", error);
    }
}


async function checkAndAddUpsellProduct() {
    try {
        let cartResponse = await fetch("/cart.js");
        let cart = await cartResponse.json();

        const upsellElement = document.querySelector("[data-upsell-id]");
        if (!upsellElement) return;

        const upsellVariantId = upsellElement.getAttribute("data-upsell-id");
        let isUpsellInCart = cart.items.some(item => item.id == upsellVariantId);

        if (!isUpsellInCart) {
            let upsellResponse = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: upsellVariantId, quantity: 1 }),
            });

            let upsellData = await upsellResponse.json();
            console.log("Upsell product added:", upsellData);
          
            checkCartAndShowUpsell();
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            debouncedCheckUpsellCheckbox();
            checkCartAndShowUpsell();
            updateCartCount();
        }
    } catch (error) {
        console.error("Error checking and adding upsell product:", error);
    }
}


async function toggleUpsell(checkbox) {
    try {
        const upsellVariantId = checkbox.getAttribute("data-upsell-id");

        let response;
        if (checkbox.checked) {
            response = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: upsellVariantId, quantity: 1 }),
            });
        } else {
            response = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: upsellVariantId, quantity: 0 }),
            });
        }

        let data = await response.json();
        console.log(checkbox.checked ? "Upsell added:" : "Upsell removed:", data);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        debouncedCheckUpsellCheckbox();
        debouncedCheckUpsellInCart();
        checkCartAndShowUpsell();
        updateCartCount();
    } catch (error) {
        console.error("Error toggling upsell product:", error);
    }
}

async function checkUpsellCheckbox() {
    try {
        let response = await fetch("/cart.js");
        let cart = await response.json();

        document.querySelectorAll("[data-upsell-id]").forEach(checkbox => {
            const upsellVariantId = checkbox.getAttribute("data-upsell-id");
            checkbox.checked = cart.items.some(item => item.id == upsellVariantId);
        });
    } catch (error) {
        console.error("Error checking upsell checkbox:", error);
    }
}


async function checkUpsellInCart() {
    console.log("checkUpsellInCart function called");

    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const upsellElement = document.getElementById('cart-upsell');
        if (!upsellElement) {
            console.log("Upsell element not found");
            return;
        }

        const upsellId = upsellElement.getAttribute('data-upsell-id');
        console.log("Upsell ID:", upsellId);

        const isProductInCart = cart.items.some(item => item.id.toString() === upsellId);
        console.log("Is upsell product in cart?", isProductInCart);

        const checkbox = document.querySelector(`input[data-upsell-id="${upsellId}"]`);
        if (checkbox) {
            checkbox.checked = isProductInCart;
            console.log("Checkbox updated:", checkbox.checked);
        }
    } catch (error) {
        console.error("Error fetching cart data:", error);
    }
}


function checkCartAndShowUpsell() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let upsellSection = document.getElementById('cart-upsell-section');
      if (upsellSection && cart.item_count > 0) {
        upsellSection.style.display = 'block';
      } else if (upsellSection) {
        upsellSection.style.display = 'none';
      }
    })
    .catch(error => console.error('Error fetching cart data:', error));
}

document.addEventListener("DOMContentLoaded", function() {
  checkCartAndShowUpsell();
});

document.addEventListener('cart:updated', function() {
  checkCartAndShowUpsell();
});